<template>
  <div v-cloak>
    <div class="header syTitle acea-row row-center-wrapper">
          {{title}}
    </div>
    <div class="detailView row-center-wrapper syDetail">{{detail}}</div>
    <div class="item acea-row row-between-wrapper" v-for="(item, index) in tradeImageList"
        :key="index">
        <div class="pictrue">
          <img :src="item" class="imageStyle" />
        </div>
    </div>
    <div class="acea-row row-center-wrapper syDetail">价格: ￥{{price}}元</div>
    
    <div class="header btnView acea-row row-center-wrapper" @click="toCodeDetail" type="submit">我要推荐，生成推荐二维码</div>
  </div>
</template>
<style>
.detailView {
  margin: 10px;
  color: #000000;
  font-size: 10px;
  display: flex;
  justify-content: center;
  border-radius:10px;
}
.btnView {
  height: 40px;
  margin: 20px;
  background-color: #e93323;
  color: #fff;
  font-size: 20px;
  display: flex;
  justify-content: center;
  border-radius:10px;
}
.syTitle {
  height: 50px;
  /* background-color: #e93323; */
  color: #000000;
  font-size: 20px;
}
.mask {
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
}
.footer .icon-shoucang1 {
  color: #e93323;
}
.product-con .product-intro .conter div {
  width: 100% !important;
}
.syDetail {
  font-size: 14px;
}

.generate-posters {
  width: 100%;
  height: 1.7rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}
.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}
.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
.imageStyle {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
<script>

import {
  getProductDetail
} from "@api/public";

import { isWeixin } from "@utils/index";
import { mapGetters } from "vuex";
import { log } from 'util';
import cookie from "@utils/store/cookie";
export default {
  name: "GoodsCon",
  components: {
  },
  data: function() {
    return {
      title: "",
      price: 0,
      detail: "",
      tradeImageList:[]
    };
  },
  computed: mapGetters(["isLogin"]),
  mounted: function() {
    this.productId = this.$route.params.id;
    this.unionId = cookie.get("lishu-openid");
    log('productId is '+this.productId);
    log('unionId is '+this.unionId);
    this.productCon();
  },


  methods: {
    //产品详情接口；
    productCon: function() {
      let that = this;
      getProductDetail(that.productId)
        .then((res) => {
          that.$set(that, "tradeImageList", res.data.img);
          that.$set(that, "title", res.data.name);
          that.$set(that, "price", res.data.price);
          that.$set(that, "detail", res.data.desc);
        })
        .catch(res => {
          // that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
    },
    //产品详情接口；
    toCodeDetail: function() {
      log('toCodeDetail is '+this.productId);

      this.$router.push({
        path: "/codeDetail/"+this.productId+'?unionid='+this.unionId
      });
    },
  }
};
</script>
